/* Boreal: Deck Builder page helpers (sections/boreal-deckbuilder.liquid)
   The BinderPOS widget only reads "4 Card Name" or "Card Name". This tidies pasted lists
   into that format (4x, Arena/MTGO/Moxfield set codes and foil marks, SB: prefixes,
   section headers, comments) and offers an example deck. It only edits the textarea. */
(function () {
  var root = document.querySelector('[data-bdb]');
  if (!root) return;

  var EXAMPLE = [
    '4 Lightning Bolt',
    '4 Shock',
    '4 Llanowar Elves',
    '4 Giant Growth',
    '2 Cultivate',
    '4 Evolving Wilds'
  ].join('\n');

  var HEADERS = /^(deck|main ?deck|mainboard|sideboard|commander|companion|maybeboard|considering|about|name .*|tokens?)\s*:?\s*$/i;

  function tidy(text) {
    var out = [];
    String(text || '').split(/\r?\n/).forEach(function (raw) {
      var line = raw.replace(/ /g, ' ').trim();
      if (!line) return;
      if (/^(\/\/|#)/.test(line)) return;                 // comments
      if (HEADERS.test(line)) return;                      // section headers
      line = line.replace(/^SB:\s*/i, '');                 // MTGO sideboard prefix
      line = line.replace(/\s+\*[A-Z]+\*\s*$/i, '');       // Moxfield *F* / *E* finish marks
      line = line.replace(/\s+\([A-Z0-9]{2,6}\)\s+[\w-]+\s*$/i, ''); // (SET) 123
      line = line.replace(/\s+\[[A-Z0-9]{2,6}\]\s*$/i, ''); // [SET]
      line = line.replace(/\s+\([A-Z0-9]{2,6}\)\s*$/i, ''); // (SET)
      var m = line.match(/^(\d+)\s*[xX]?\s+(.+)$/);
      if (m) line = m[1] + ' ' + m[2].trim();
      out.push(line);
    });
    // Merge duplicate card lines (e.g. same card in main and sideboard)
    var order = [], qty = {};
    out.forEach(function (l) {
      var m = l.match(/^(\d+) (.+)$/), n = m ? parseInt(m[1], 10) : 1, name = m ? m[2] : l, key = name.toLowerCase();
      if (!(key in qty)) { order.push(name); qty[key] = 0; }
      qty[key] += n;
    });
    return order.map(function (name) { return qty[name.toLowerCase()] + ' ' + name; }).join('\n');
  }

  // Set the value the way a user would, so the widget's own state updates.
  function setValue(ta, value) {
    var setter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set;
    setter.call(ta, value);
    ta.dispatchEvent(new Event('input', { bubbles: true }));
    ta.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function textarea() { return root.querySelector('#decklist-render-container textarea'); }

  function clean(ta) {
    if (!ta || !ta.value) return;
    var next = tidy(ta.value);
    if (next && next !== ta.value) setValue(ta, next);
  }

  // Paste: tidy right after the paste lands. Blur: tidy before the submit click registers.
  root.addEventListener('paste', function (e) {
    if (e.target && e.target.matches('#decklist-render-container textarea')) setTimeout(function () { clean(e.target); }, 0);
  });
  root.addEventListener('focusout', function (e) {
    if (e.target && e.target.matches('#decklist-render-container textarea')) clean(e.target);
  });

  var ex = root.querySelector('[data-bdb-example]');
  if (ex) ex.addEventListener('click', function () {
    var ta = textarea();
    if (!ta) {
      // Widget still loading, or showing results: go back to the list first.
      var back = root.querySelector('.re-enter-btn');
      if (back) back.click();
      setTimeout(function () { var t = textarea(); if (t) { setValue(t, EXAMPLE); t.focus(); } }, 300);
    } else {
      setValue(ta, EXAMPLE);
      ta.focus();
    }
    root.querySelector('.bdb__app').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Label the widget's icon-only buttons for screen readers once they render.
  var labels = {
    '.re-enter-btn': 'Back to decklist',
    '.copy-btn': 'Copy results',
    '.sync-addedList-btn': 'Reset deck to suggested printings',
    '.result-push-to-added': 'Move to your deck',
    '.add-item-btn': 'Add another printing',
    '.item-remove': 'Remove from deck'
  };
  var app = root.querySelector('#decklist-render-container');
  if (app && 'MutationObserver' in window) {
    new MutationObserver(function () {
      Object.keys(labels).forEach(function (sel) {
        app.querySelectorAll(sel + ':not([aria-label])').forEach(function (b) { b.setAttribute('aria-label', labels[sel]); b.setAttribute('title', labels[sel]); });
      });
    }).observe(app, { childList: true, subtree: true });
  }
})();
